<nz-form-label [attr.nzFor]="formFieldInfo.fieldCode" [hidden]="hideTitle">
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control [formGroup]="formGroup">
    <textarea style="width:100%" nz-input [attr.id]="formFieldInfo.fieldCode" [attr.maxlength]="maxLength"
        [attr.minlength]="minLength" [formControlName]="formFieldInfo.fieldCode" nzSize="large" [(ngModel)]="value"
        (ngModelChange)="modelChange()"></textarea>
</nz-form-control>